'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _package = { version: '3.1.6' };

exports['default'] = _package.version;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/version/index.js
// module id = 1529
// module chunks = 0